/**
 * @generated SignedSource<<a6e2d0c441102314e1b6b57a7ec573de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileScreenEmployeeTodaysShifts_employee$data = {
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeTodaysShifts_employeeShift">;
  }>;
  readonly " $fragmentType": "ProfileScreenEmployeeTodaysShifts_employee";
};
export type ProfileScreenEmployeeTodaysShifts_employee$key = {
  readonly " $data"?: ProfileScreenEmployeeTodaysShifts_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeTodaysShifts_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileScreenEmployeeTodaysShifts_employee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileScreenEmployeeTodaysShifts_employeeShift"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "d2649444f3ad2ea4a8fa592765ed19b5";

export default node;
